module.exports = __webpack_public_path__ + "img/aguas.c2651120.svg";